export const parseHexColor = (hexRGB: string) => {
  return {
    r: +parseInt(hexRGB.substring(1, 3), 16),
    g: +parseInt(hexRGB.substring(3, 5), 16),
    b: +parseInt(hexRGB.substring(5, 7), 16),
  };
};
